import useCheckDetailsViewModel from '../CheckDetailsViewModel'

import CircleSpinner from '@components/shared/CircleSpinner'
import CheckDetailsEditTable from './CheckDetailsEditTable'
import { FaFileExport, FaFileDownload } from 'react-icons/fa'
import { MdKeyboardArrowLeft } from 'react-icons/md'

import './CheckDetailsEdit.css'

// September 27th, 2023
// Don't delete this screen yet, as we may need it for annotators
const CheckDetailsEdit = () => {
    
    const {
        
        navigate,
        
        error,
        loading,
        pageIndex,
        setPageIndex,
        checkDetails,
        pageImageUrl,
        isExporting,
        isDownloading,
        
        check,
        
        onUpdateCheck,
        onExportCheckClick,
        onDownloadCheckClick,
        
    } = useCheckDetailsViewModel()
    
    if (error) return (
        <div className="w-full Check">
            <p>Failed to load check</p>
        </div>
    )
    
    if (!check) return (
        <div className="w-full CheckDetailsEdit">
            <CircleSpinner className="absolute-centered" />
        </div>
    )
    
    if (!check?.pages?.length) return (
        <div className="w-full CheckDetailsEdit">
            <p>No pages found for check</p>
        </div>
    )
    
    return (
        
        <div className="w-full CheckDetailsEdit">
            
            <header>
                <div className="flex items-center content-center">
                    <button
                        className="mr-2 btn btn-link flex items-center content-center"
                        onClick={() => navigate.toCheckDetail(check.id)}>
                        <MdKeyboardArrowLeft />
                        <span className="ml-2">Back</span>
                    </button>
                    <h3>{check.name}</h3>
                </div>
                <div className="flex items-center content-center justify-end">
                    <button
                        className="mr-2 btn btn-success flex items-center content-center"
                        disabled={isExporting}
                        onClick={onExportCheckClick}>
                        <FaFileExport />
                        <span className="ml-2">
                            {isExporting ? 'Exporting...' : 'Export'}
                        </span>
                    </button>
                    <button
                        className="mr-2 btn btn-secondary flex items-center content-center"
                        onClick={onDownloadCheckClick}>
                        <FaFileDownload />
                        <span className="ml-2">
                            {isDownloading ? 'Downloading...' : 'Download'}
                        </span>
                    </button>
                </div>
            </header>
            
            <CheckDetailsEditTable
                className="mt-2"
                loading={loading}
                check={check}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                details={checkDetails}
                currentPageImageUrl={pageImageUrl}
                onUpdateCheck={onUpdateCheck} />
        
        </div>
        
    )
    
}

export default CheckDetailsEdit
